export const USER_MANAGEMENT_BASE_URL = '/userManagement';
export const LOCAL_ACCOUNTS_BASE_URL = '/userManagement/localAccount';
